export const text = {
  News: "Nieuws",
  AddNews: "Nieuws toevoegen",
  NewsOrder: "Nieuwsvolgorde",
  Author: "Auteur",
  ModifiedDate: "Publicatiedatum",
  Article: "Artikel",
  NewsDeletedsuccessfully: "Nieuws succesvol verwijderd",
  Newsaddedsuccessfully: "Nieuws succesvol toegevoegd",
  Newsupdatedsuccessfully: "Nieuws succesvol bijgewerkt",
  EnterTitle: "Titel",
  EnterAuthor: "Auteur",
  EnterSubtitle: "Subtitel",
  Order: "Volgorde",
  AssignTeam: "Team toewijzen",
  choosebanner: "Kies banner",
  choosevideo: "Kies video",
  ForTeam: "Voor team",
  Content: "Inhoud",
  Banner: "Banner",
  Author: "Auteur",
};
